import { handleActions, createAction } from "redux-actions";
import * as Immutable from "immutable";

const defaultState = Immutable.fromJS({
  hasNewVersion: false,
  apiState: ""
});

export const newVersionAvailable: Action = createAction(
  "NEW_VERSION_AVAILABLE"
);

export const apiStateReceived: Action = createAction("API_STATE_RECEIVED");

const statusReducer = handleActions(
  {
    [newVersionAvailable](state) {
      return state.set("hasNewVersion", true);
    },
    [apiStateReceived](state, { payload }) {
      return state.set(
        "apiState",
        payload.state === "ready" ? "" : payload.state
      );
    }
  },
  defaultState
);

export default statusReducer;



// WEBPACK FOOTER //
// ./src/statusReducer.js